import { Action } from '@ngrx/store';
import { Update } from '@ngrx/entity';
import { DeviceSetting } from '../device-setting.model';

export enum DeviceSettingActionTypes {
  LoadDeviceSetting = '[DeviceSetting] Load DeviceSetting',
  UpdateDeviceSetting = '[DeviceSetting] Update DeviceSetting',
  UpdateDevicesSettingFail = '[DeviceSetting] Update Devices Setting Fail'
}

export class LoadDeviceSetting implements Action {
  readonly type = DeviceSettingActionTypes.LoadDeviceSetting;

  constructor(public payload: any = null) {}
}

export class UpdateDeviceSetting implements Action {
  readonly type = DeviceSettingActionTypes.UpdateDeviceSetting;

  constructor(public payload: any = null) {}
}

export class UpdateDevicesSettingFail implements Action {
  readonly type = DeviceSettingActionTypes.UpdateDevicesSettingFail;
}

export type DeviceSettingActions =
LoadDeviceSetting
 | UpdateDeviceSetting
 | UpdateDevicesSettingFail;
